export default __webpack_public_path__ + "static/media/cake.27639fe4.png";